import { render, staticRenderFns } from "./PrintMenu.vue?vue&type=template&id=bbca7e3c&scoped=true"
import script from "./PrintMenu.vue?vue&type=script&lang=js"
export * from "./PrintMenu.vue?vue&type=script&lang=js"
import style0 from "./PrintMenu.vue?vue&type=style&index=0&id=bbca7e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbca7e3c",
  null
  
)

export default component.exports